export default __webpack_public_path__ + "static/media/kirka.8a48b2df.svg";